import { useCallback, useMemo, useState } from 'react'
import { useLocation } from 'react-router'
import { PaginationData } from './Pagination.types'

const initialPagination = (
    query: URLSearchParams,
    callback: (page: number, pageSize: number) => any
) => {
    const page = initialPage(query)
    const pageSize = initialPageSize(query)
    callback(page, pageSize)
}

const initialPage = (query: URLSearchParams): number => {
    const value = parseInt(query.get('page') || '')
    return isNaN(value) ? 1 : value
}

const initialPageSize = (query: URLSearchParams): number => {
    const value = parseInt(query.get('pageSize') || '')
    return isNaN(value) ? 20 : value
}

const getOffset = (page: number, pageSize: number): number => {
    return (page - 1) * pageSize
}

const usePagination = (clearCallback: () => any): PaginationData => {
    const qs = useLocation().search
    const query = useMemo(() => new URLSearchParams(qs), [qs])

    const [page, setPage] = useState<number>(initialPage(query))
    const [pageSize, setPageSize] = useState<number>(initialPageSize(query))

    const onChangedPage = useCallback(
        (page: number) => {
            setPage(page)
            clearCallback()
        },
        [clearCallback]
    )

    const onChangedPageSize = useCallback(
        (page: number, pageSize: number) => {
            setPage(page)
            setPageSize(pageSize)
            clearCallback()
        },
        [clearCallback]
    )

    const data = useMemo(
        () => ({
            page,
            pageSize,
            onChangedPage,
            onChangedPageSize,
        }),
        [page, pageSize, onChangedPage, onChangedPageSize]
    )

    return data
}

export {
    usePagination,
    initialPagination,
    initialPage,
    initialPageSize,
    getOffset,
}
